import BlockSpinner from "components/Spinners/BlockSpinner";
import { Table } from "components/Theme/table";
import type { WirelessSurveyDataCollectorOut } from "kubb";
import WirelessSurveySamplePointTableRows from "./WirelessSurveySamplePointTableRows";

function WirelessSurveySamplePointTab(props: {
  dataCollectors?: WirelessSurveyDataCollectorOut[];
  loading: boolean;
  refresh?: () => any;
}) {
  const { dataCollectors, loading } = props;
  return (
    <BlockSpinner loading={loading}>
      <Table className={"table-sm"} data-cy={"wireless-survey-sample-points"}>
        <thead>
          <tr>
            <th>Data Collector</th>
            <th>Sample Point Name</th>
            <th>Sample Point Start</th>
            <th>Sample Point End</th>
            <th>Included</th>
            <th> </th>
          </tr>
        </thead>
        {dataCollectors
          ?.sort((a, b) =>
            a.data_collector_name > b.data_collector_name ? 1 : -1,
          )
          .map((dataCollector) => (
            <WirelessSurveySamplePointTableRows
              key={dataCollector.data_collector_id}
              dataCollector={dataCollector}
              refresh={props.refresh}
            />
          ))}
      </Table>
    </BlockSpinner>
  );
}

export default WirelessSurveySamplePointTab;
